// prettier-ignore
enum MutationType {
  updateCurrentAreaKey = "updateCurrentAreaKey",
}

export default MutationType;
